module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        // require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function (){

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };


    module.initStickyEl = function () {
        (function () {
            const body = document.body;
            const sentinel = document.getElementById('sticky-sentinel');

            if (!sentinel) return;

            const io = new IntersectionObserver(
                (entries) => {
                    const e = entries[0];
                    if (e.isIntersecting) {
                        body.classList.remove('stuck');
                        body.classList.add('before-stuck');
                    } else {
                        body.classList.add('stuck');
                        body.classList.remove('before-stuck');
                    }
                },
                { threshold: 0 }
            );

            io.observe(sentinel);
        })();


    };



    // module.navDropdownHover = function () {
    //
    //     const $dropdown = $(".dropdown");
    //     const $dropdownToggle = $(".dropdown-toggle");
    //     const $dropdownMenu = $(".dropdown-menu");
    //     const showClass = "show";
    //
    //     $(window).on("load resize", function() {
    //         if (this.matchMedia("(min-width: 768px)").matches) {
    //             $dropdown.hover(
    //                 function() {
    //                     const $this = $(this);
    //                     $this.addClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "true");
    //                     $this.find($dropdownMenu).addClass(showClass);
    //                 },
    //                 function() {
    //                     const $this = $(this);
    //                     $this.removeClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "false");
    //                     $this.find($dropdownMenu).removeClass(showClass);
    //                 }
    //             );
    //         } else {
    //             $dropdown.off("mouseenter mouseleave");
    //         }
    //     });
    // };


    module.announcementBarDismiss = function () {
        if($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initSpotlightJs = function () {
        if ($('.spotlight').length)
            require('spotlight.js');
    };


    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        $('.slick.testimonials-slides').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            appendArrows: $('.arrows-container'),
            cssEase: 'linear',

            responsive: [

                {
                    breakpoint: 992, // sm
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });


        $('.slick.testimonials').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            cssEase: 'linear',
        });

        $('.slick.shortcode-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        $('.slick.slides').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            dots: false,
        });

        $('.slick.carousel').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable:false,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });

        $('.slick.gallery-slides').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            arrows: true,
            centerMode: true,
            cssEase: 'linear',

            responsive: [

                {
                    breakpoint: 1065, // md
                    settings: {
                        slidesToShow: 2
                    }
                },


                {
                    breakpoint: 940, // sm
                    settings: {
                        slidesToShow: 1
                    }
                },

            ]


        });

    };


        module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };

    return module;

};
